export default {
  state: {
    loading: false,
    currentLang: localStorage.getItem('lang') ? localStorage.getItem('lang') : process.env.VUE_APP_I18N_LOCALE
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    changeLang (state, lang) {
      state.currentLang = lang
    }
  },
  actions: {
    changeLang ({ commit }, lang) {
      commit('changeLang', lang)
      localStorage.setItem('lang', lang)
    }
  },
  getters: {
    getCurrentLang: (state) => state.state
  }
}
